import { createContext } from "react";

export const TabContext = createContext<string | null>(null);
